import { collection, addDoc, query, where, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from '../firebase';

async function getUserByUID(uid) {

    const q = query(collection(db, "users"), where("uid", "==", uid));
    const querySnapshot = await getDocs(q);
    let u = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(u)) {
            u = doc.data();
        } else {
            err = 'Multiple users found with the same UID';
        }
    });

    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error, e.g. multiple users found
        else if(!Boolean(u)) { resolve(null); }  // ok, but no user found
        else { resolve(u); } // ok, return user
    });
}

async function getUsersByUID(uids) {

    const q = uids = 'any' ? 
        query(collection(db, "users"), where("uid", "not-in", ['hyPRV6TXakMbalAtyb33uDFsOJb2'])) : // get all users except for answer sheet
        query(collection(db, "users"), where("uid", "in", uids)) // get array of users;
    const querySnapshot = await getDocs(q);
    let u = [], err = null;
    querySnapshot.forEach((doc) => {
        u.push(doc.data())
    });

    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error, e.g. multiple users found
        else if(!Boolean(u)) { resolve(null); }  // ok, but no user found
        else { resolve(u); } // ok, return users
    });
}

async function createUser(user) {

    return new Promise((resolve, reject) => {
        addDoc(collection(db, "users"), user)
        .then((u) => {
            resolve(user);
        }).catch((e) => reject(e));
    });
}

async function updateUser(newUser) {

    const q = query(collection(db, "users"), where("uid", "==", newUser.uid));
    const querySnapshot = await getDocs(q);
    let docid = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(docid)) {
            docid = doc.id
        } else {
            err = 'Multiple users found with the same UID';
        }
    });    

    return new Promise((resolve, reject) => {
        if(err) { reject(err) }
        const docRef = doc(db, "users", docid);
        setDoc(docRef, newUser, { merge: true})
        .then(() => resolve(newUser))
        .catch((e) => reject(e));
    });
}

export {
    createUser,
    getUserByUID,
    getUsersByUID,
    updateUser
}